var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHide = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.5a.623.623 0 0 1-.442-.183L2.683 3.567a.625.625 0 0 1 .884-.883l13.75 13.75a.624.624 0 0 1-.442 1.066Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.987 15c-1.62 0-3.184-.48-4.646-1.426-1.33-.859-2.528-2.09-3.464-3.554v-.003c.779-1.116 1.632-2.06 2.548-2.821a.078.078 0 0 0 .006-.115l-.779-.777a.078.078 0 0 0-.105-.005C2.573 7.12 1.67 8.126.848 9.304a1.247 1.247 0 0 0-.025 1.388c1.032 1.615 2.36 2.975 3.84 3.932 1.665 1.08 3.458 1.626 5.324 1.626a9.34 9.34 0 0 0 2.96-.491.079.079 0 0 0 .05-.096.079.079 0 0 0-.02-.034l-.842-.842a.156.156 0 0 0-.15-.04A8 8 0 0 1 9.987 15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.173 9.32C18.14 7.722 16.8 6.364 15.296 5.393c-1.663-1.075-3.5-1.643-5.31-1.643a8.88 8.88 0 0 0-2.925.5.078.078 0 0 0-.03.13l.843.842a.156.156 0 0 0 .151.039A7.532 7.532 0 0 1 9.987 5c1.59 0 3.147.485 4.63 1.445 1.356.875 2.569 2.105 3.507 3.555a.005.005 0 0 1 0 .006 12.136 12.136 0 0 1-2.505 2.84.078.078 0 0 0-.023.089c.004.01.01.02.017.027l.777.777a.078.078 0 0 0 .106.005 13.42 13.42 0 0 0 2.681-3.066 1.258 1.258 0 0 0-.004-1.358Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25c-.281 0-.561.03-.835.093a.078.078 0 0 0-.039.132l4.398 4.397a.078.078 0 0 0 .132-.039A3.75 3.75 0 0 0 10 6.249Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.476 9.128a.078.078 0 0 0-.132.039 3.75 3.75 0 0 0 4.492 4.492.077.077 0 0 0 .059-.054.078.078 0 0 0-.02-.078l-4.4-4.4Z",
    fill: "currentColor"
  })));
};
export { SvgHide as ReactComponent };